import { PageController } from '@client/components/_core/layout/PageController';
import { GovernanceCheckEdit } from '@client/components/mspr/governance-check-edit';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/mspr/service-providers/details/$id/manage/check/$checkId')({
    staticData: {
        presentation: 'overlay',
        ui: { useParentTitle: true },
    },
    params: {
        parse({ checkId }) {
            return { checkId: BigInt(checkId) };
        },
    },
    component: GovernanceCheckRoute,
});

function GovernanceCheckRoute() {
    const { id: providerId, checkId } = Route.useParams();
    const orgId = useOrgId();
    const navigate = useNavigate();
    const { trpcUtils } = useTrpc();

    return (
        <PageController route={Route}>
            <GovernanceCheckEdit
                action={['edit', checkId, providerId]}
                onClose={async () => {
                    await trpcUtils.mspr.governanceCheck.invalidate();
                    navigate({
                        to: '/console/$orgId/mspr/service-providers/details/$id/manage',
                        params: { orgId, id: providerId },
                        fromComponent: 'drawer',
                    });
                }}
            />
        </PageController>
    );
}
